import { useLocation } from 'react-router-dom-v5-compat';

import { SEARCH_BY_NAME_OPEN_PARAM } from '../constants';

import { useSearchByNameExperiment } from './useSearchByNameExperiment';

export const useSearchByNameRedirect = (): boolean => {
  const { search } = useLocation();
  const { isEnabled } = useSearchByNameExperiment();
  const hasOpenParam = new URLSearchParams(search).get(SEARCH_BY_NAME_OPEN_PARAM) === 'true';
  return hasOpenParam && isEnabled;
};
